import React from 'react';
import { PUBLIC_PATH } from '../shared/config/routes-config';

export function NotFoundData({ showMessage = true }) {
  return (
    <div className="flex justify-center flex-col text-center w-full">
      <img
        src={`${PUBLIC_PATH}/assets/pngs/emptyNest.png`}
        alt="no-data"
        className="size-[400px] mx-auto mb-4"
      />
      {showMessage && (
        <h3 className="text-2xl font-gilroy-medium text-neutral-900">No Data Available</h3>
      )}
    </div>
  );
}
